import { useEffect } from "react";

import { matterPortPlayButtonClicked } from "@/dataLayer/dataLayer";

const useEnterVirtualTourHandler = (loaded: boolean) => {
  const eventTypes = ["enter_vr_tour"];

  useEffect(() => {
    if (!loaded) return;

    const handleMessage = (event: MessageEvent) => {
      if (event.data && event.data.type && eventTypes.includes(event.data.type)) {
        if (event.data.type === "enter_vr_tour") {
          matterPortPlayButtonClicked("enter_vr_tour", event.data.source, "matterport_play_button_clicked");
        }
      }
    };

    window.addEventListener("message", handleMessage);

    return () => {
      window.removeEventListener("message", handleMessage);
    };
  }, [loaded]);
};

export default useEnterVirtualTourHandler;
